// The pop-up's Previous / Next walk the list it was opened from, across page boundaries. Pure, so
// the edges (first person, last person, a short last page) are tested. The pager is `components/Pager`.

/** "12 of 1,284": where a row on a page sits in the whole list, 1-based. */
export function listPosition(page: number, pageSize: number, index: number): number {
  return (page - 1) * pageSize + index + 1;
}

export type NavStep =
  | { readonly kind: 'row'; readonly index: number }
  | { readonly kind: 'page'; readonly page: number; readonly at: 'first' | 'last' };

/** Where Previous (-1) or Next (+1) goes from a row; null at either end of the whole list. */
export function stepFrom(direction: -1 | 1, index: number, rowCount: number, page: number, pageCount: number): NavStep | null {
  const target = index + direction;
  if (target >= 0 && target < rowCount) return { kind: 'row', index: target };
  if (direction === -1) return page > 1 ? { kind: 'page', page: page - 1, at: 'last' } : null;
  return page < pageCount ? { kind: 'page', page: page + 1, at: 'first' } : null;
}
